import React from 'react';
import { Sparkles, TrendingUp } from 'lucide-react';

/**
 * Public "Nuestra historia" card — shows long-form text with the Sparkles icon.
 */
export function HistoryCard({ text, title = 'Nuestra historia', testid = 'profile-history-card' }) {
  if (!text) return null;
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6" data-testid={testid}>
      <h2 className="font-serif text-xl font-bold text-habita-dark flex items-center gap-2">
        <Sparkles className="w-5 h-5 text-habita" /> {title}
      </h2>
      <p className="text-sm text-gray-700 mt-3 whitespace-pre-line leading-relaxed">{text}</p>
    </div>
  );
}

/**
 * Placeholder stats card — shows up to N labelled cells with "—" content and a
 * "Próximamente" badge. Will be wired to real analytics in Phase 2B.
 *
 * Props: labels (string[]), title (default 'Estadísticas'), testid.
 */
export function StatsSoonCard({ labels, title = 'Estadísticas', testid = 'profile-stats-soon', subtitle }) {
  const list = Array.isArray(labels) ? labels : [];
  if (!list.length) return null;
  return (
    <div className="bg-white rounded-2xl border border-dashed border-gray-300 p-6" data-testid={testid}>
      <div className="flex items-center gap-2 mb-3">
        <TrendingUp className="w-5 h-5 text-habita" />
        <h2 className="font-serif text-xl font-bold text-habita-dark">{title}</h2>
        <span className="px-2 py-0.5 rounded-full bg-habita-mint text-habita text-[10px] font-bold uppercase">Próximamente</span>
      </div>
      <div className={`grid grid-cols-2 ${list.length >= 4 ? 'sm:grid-cols-4' : 'sm:grid-cols-3'} gap-3`}>
        {list.map(label => (
          <div key={label} className="bg-habita-cream rounded-xl p-4 text-center">
            <p className="text-2xl font-bold text-habita-dark/40">—</p>
            <p className="text-[10px] uppercase tracking-wider text-gray-500 mt-1">{label}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-3 text-center">
        {subtitle || 'Métricas de desempeño disponibles próximamente en tu dashboard.'}
      </p>
    </div>
  );
}
